// extracted by mini-css-extract-plugin
export default {"checkbox":"VikTLA","checkboxError":"GTrXQp"};